import React from 'react';
export function ConceptTPV() {
  const pillars = [{
    label: 'TRECUT',
    subtitle: 'Rădăcina emoțională',
    body: 'Identificăm și vindecăm rădăcina emoțională. Traumele, pierderile și tiparele vechi care încă îți influențează deciziile ies la suprafață și se eliberează, cu blândețe, prin tehnici NLP.'
  }, {
    label: 'PREZENT',
    subtitle: 'Conștientizare și Acceptare',
    body: 'Stabilizăm emoțiile și readucem echilibrul. Prin conștientizare, acceptare și meditație ghidată, înveți să îți reglezi stările și să iei decizii din claritate, nu din frică.'
  }, {
    label: 'VIITOR',
    subtitle: 'Claritate și Direcție',
    body: 'Construim o viziune clară și realistă. Primești direcție, pași concreți și mentorare personalizată pentru a face alegeri conștiente și a-ți reconstrui viața pas cu pas.'
  }];
  return <section className="bg-blush py-24 md:py-32" data-id="element-78">
      <div className="max-w-[1180px] mx-auto px-6 space-y-16" data-id="element-79">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto space-y-6" data-id="element-80">
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-cyan" data-id="element-81">
            Terapia T.P.V. — Trecut · Prezent · Viitor
          </h2>
          <p className="text-lg leading-relaxed text-navy" data-id="element-82">
            Procesul prin care vindeci rădăcina emoțională din trecut,
            stabilizezi prezentul și construiești o viziune clară și realistă
            pentru viitor.
          </p>
        </div>

        {/* Venn Diagram - CSS Built */}
        <div className="flex justify-center" data-id="element-83">
          <div className="relative w-[340px] h-[320px] md:w-[480px] md:h-[440px]" data-id="element-84">
            {/* Circle: PREZENT (top center) */}
            <div className="absolute left-1/2 -translate-x-1/2 top-0 w-[200px] h-[200px] md:w-[280px] md:h-[280px] rounded-full bg-white border-2 border-cardBorder flex flex-col items-center text-center px-6 z-10 pt-8 md:pt-12" data-id="element-85">
              <span className="font-serif text-lg md:text-2xl font-medium text-navy tracking-wide" data-id="element-86">
                PREZENT
              </span>
              <span className="text-xs md:text-sm font-medium text-magenta mt-1" data-id="element-87">
                Conștientizare
              </span>
              <span className="text-xs md:text-sm font-medium text-magenta" data-id="element-88">
                și Acceptare
              </span>
            </div>

            {/* Circle: TRECUT (bottom left) */}
            <div className="absolute left-0 bottom-0 w-[200px] h-[200px] md:w-[280px] md:h-[280px] rounded-full bg-white border-2 border-cardBorder flex flex-col items-center text-center px-6 z-10 justify-end pb-8 md:pb-12" data-id="element-89">
              <span className="font-serif text-lg md:text-2xl font-medium text-navy tracking-wide" data-id="element-90">
                TRECUT
              </span>
              <span className="text-xs md:text-sm font-medium text-magenta mt-1" data-id="element-91">
                Rădăcina
              </span>
              <span className="text-xs md:text-sm font-medium text-magenta" data-id="element-92">
                emoțională
              </span>
            </div>

            {/* Circle: VIITOR (bottom right) */}
            <div className="absolute right-0 bottom-0 w-[200px] h-[200px] md:w-[280px] md:h-[280px] rounded-full bg-white border-2 border-cardBorder flex flex-col items-center text-center px-6 z-10 justify-end pb-8 md:pb-12" data-id="element-93">
              <span className="font-serif text-lg md:text-2xl font-medium text-navy tracking-wide" data-id="element-94">
                VIITOR
              </span>
              <span className="text-xs md:text-sm font-medium text-magenta mt-1" data-id="element-95">
                Claritate
              </span>
              <span className="text-xs md:text-sm font-medium text-magenta" data-id="element-96">
                și Direcție
              </span>
            </div>

            {/* Center overlap label */}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/4 z-20" data-id="element-97">
              <div className="w-[100px] h-[100px] md:w-[130px] md:h-[130px] rounded-full bg-magenta flex flex-col items-center justify-center text-center" data-id="element-98">
                <span className="font-serif text-xs md:text-sm font-semibold text-white leading-tight tracking-wide" data-id="element-99">
                  TERAPIA
                </span>
                <span className="font-serif text-sm md:text-lg font-bold text-white leading-tight" data-id="element-100">
                  T.P.V.
                </span>
              </div>
            </div>

            {/* Decorative connecting lines */}
            <svg className="absolute inset-0 w-full h-full z-0 pointer-events-none" viewBox="0 0 480 440" data-id="element-101">
              {/* Curved arrow: Trecut → Prezent */}
              <path d="M 140 200 Q 100 100 200 80" fill="none" stroke="#c48b9f" strokeWidth="1.5" strokeDasharray="6 4" data-id="element-102" />
              <polygon points="198,84 208,76 200,90" fill="#c48b9f" data-id="element-103" />

              {/* Curved arrow: Prezent → Viitor */}
              <path d="M 300 80 Q 400 100 360 200" fill="none" stroke="#c48b9f" strokeWidth="1.5" strokeDasharray="6 4" data-id="element-104" />
              <polygon points="358,198 366,208 352,200" fill="#c48b9f" data-id="element-105" />

              {/* Curved arrow: Viitor → Trecut */}
              <path d="M 300 360 Q 240 400 180 360" fill="none" stroke="#c48b9f" strokeWidth="1.5" strokeDasharray="6 4" data-id="element-106" />
              <polygon points="182,358 172,366 180,352" fill="#c48b9f" data-id="element-107" />
            </svg>
          </div>
        </div>

        {/* Pillars */}
        <div className="grid md:grid-cols-3 gap-8 pt-8" data-id="element-108">
          {pillars.map((pillar, index) => <div key={index} className="bg-white rounded-2xl border border-cardBorder p-8 space-y-4" data-id="element-109">
              <div className="w-full h-1 bg-magenta rounded-full" data-id="element-110"></div>
              <h3 className="font-serif text-2xl font-medium text-magenta" data-id="element-111">
                {pillar.label}
              </h3>
              <p className="text-xs font-medium tracking-widest uppercase text-muted" data-id="element-112">
                {pillar.subtitle}
              </p>
              <p className="text-base leading-relaxed text-navy" data-id="element-113">
                {pillar.body}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}